var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.00781H16.3337L12.8663 0.407813C12.5196 0.149132 12.0988 0.00888542 11.6663 0.0078125H6C5.46957 0.0078125 4.96086 0.218526 4.58579 0.593599C4.21071 0.968672 4 1.47738 4 2.00781V4.00781H2C1.46957 4.00781 0.960859 4.21853 0.585786 4.5936C0.210714 4.96867 0 5.47738 0 6.00781V20.0078C0 20.5382 0.210714 21.047 0.585786 21.422C0.960859 21.7971 1.46957 22.0078 2 22.0078H21.1112C21.612 22.0072 22.092 21.8079 22.4461 21.4539C22.8001 21.0998 22.9993 20.6198 23 20.1191V18.0078H25.1112C25.612 18.0072 26.092 17.8079 26.4461 17.4539C26.8001 17.0998 26.9993 16.6198 27 16.1191V5.00781C27 4.47738 26.7893 3.96867 26.4142 3.5936C26.0391 3.21853 25.5304 3.00781 25 3.00781ZM25 16.0078H23V9.00781C23 8.47738 22.7893 7.96867 22.4142 7.5936C22.0391 7.21853 21.5304 7.00781 21 7.00781H12.3337L8.86625 4.40781C8.51955 4.14913 8.09882 4.00889 7.66625 4.00781H6V2.00781H11.6663L15.4 4.80781C15.5731 4.93763 15.7836 5.00781 16 5.00781H25V16.0078Z",
    fill: "url(#paint0_linear_1229_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1229_9",
    x1: 13.5,
    y1: 0.0078125,
    x2: 13.5,
    y2: 22.0078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46BCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.5218fe7c27f423a04ff8c6b0922b52b6.svg";
export { ForwardRef as ReactComponent };